<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y content-class="border-menu" :max-height="maxHeight")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined height="48" min-width="240")
        .d-flex.align-center.fill-height.text-sm.px-3
          .flex-grow-1.text-left(v-if="value") {{ showValue(value) }}
          .flex-grow-1.neutral500--text.text-left(v-else) Enter name or phone number
          v-icon(size="20") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="searchMember" outlined placeholder="Enter name or phone number" autofocus dense hide-details clearable)
        v-divider
      .d-flex.align-center.px-4.py-3
        .font-semibold Existing member
        y-pagination(v-model="page" :pageSize="fetchCount" :count="count" :loading="isFetching")
      v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-for="item in members")
        div.px-4.py-2(v-if="isItemDisabled(item)" style="width: 100%; background-color: var(--v-infoT08)")
          .text-sm.neutral700--text {{ item.name }}
          v-row.mt-1(no-gutters)
            v-col(cols="4")
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-phone
                .text-xs.neutral500--text.ml-1 +{{ item.phone }}
            v-col
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-mail-02
                .text-xs.neutral500--text.ml-1 {{ item.email }}
        div.px-4.py-2.clickable.hover-bg(v-else style="width: 100%;" @click="selectItem(item)")
          .text-sm.neutral700--text {{ item.name }}
          v-row.mt-1(no-gutters)
            v-col(cols="4")
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-phone
                .text-xs.neutral500--text.ml-1 +{{ item.phone }}
            v-col
              div.d-flex.align-center
                v-icon(size="15" color="var(-v-neutral500)") $yzi-mail-02
                .text-xs.neutral500--text.ml-1 {{ item.email }}
        v-divider
      template(v-if="!members.length")
        .px-4.py-3 No results match

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'

export default {
  props: {
    value: {
      required: true
    },
    maxHeight: {
      default: 250
    }
  },
  data: () => ({
    searchMember: null,
    show: false,
    isFetching: false,
    isLoading: false,
    page: 1,
    fetchCount: 20,
    count: 0,
    members: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    })
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchMembers(this.searchMember)
      } else {
        if (this.value) {
          this.searchMember = typeof this.value === 'object' ? this.value.name : this.value
        }
        this.$emit('change')
      }
    },
    page () {
      this.fetchMembers(this.searchMember)
    },
    searchMember () {
      this.searchStart()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchMembers (val) {
      this.isFetching = true
      let params = {
        dormant: false,
        search: val || '',
        page: this.page
      }
      if (!val) {
        params.ordering = '-created'
      }
      this.$axios.get(`/loyalty/${this.company.slug}/members`, { params })
        .then(resp => {
          this.members = resp.data.results
          this.count = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    searchStart: debounce(function () {
      this.page = 1
      this.fetchMembers(this.searchMember)
    }, 750),
    selectItem (item) {
      this.$emit('input', item)
      this.show = false
      // this.searchMember = item.ic
    },
    showValue (val) {
      if (typeof val === 'object') {
        return val.name
      } else {
        return val
      }
    },
    isItemDisabled(item) {
      let comp1 = null
      let comp2 = null
      if (this.value && typeof this.value === 'object') {
        comp1 = this.value.id
      } else {
        comp1 = this.value
      }
      if (item && typeof item === 'object') {
        comp2 = item.id
      } else {
        comp2 = item
      }
      return comp1 === comp2
    },
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
</style>